<template>
  <div class="mt-6 text-sm">
    <loader v-if="editions === null" />
    <div v-else>
      <panel v-if="editions.data.length === 0" class="pt-6">
        <div>
          <i class="fas fa-info-circle"></i> No e-zines have been created.
        </div>
      </panel>
      <panel v-else class="pt-6">
        <div class="overflow-x-auto">
          <table class="table-auto text-center w-full">
            <thead class="uppercase text-xs">
              <tr class="whitespace-no-wrap">
                <th class="text-left p-2">Edition Name</th>
                <th class="p-2">Created At</th>
                <th class="p-2">Approved At</th>
                <th class="p-2">View</th>
                <th class="p-2">Edit Content</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="edition in editions.data" :key="edition.id">
                <td class="text-left p-2">{{ edition.name }}</td>
                <td class="p-2" v-if="!edition.created_at">-</td>
                <td class="p-2" v-else>{{ edition.created_at | date }}</td>
                <td class="p-2" v-if="!edition.approved_at">
                  <strong>Not Approved</strong>
                  <small class="block text-grey-dark mt-1">
                    Auto Approval:
                    <span v-if="edition.auto_approve_at">{{ edition.auto_approve_at | date }}</span>
                    <span v-else>Disabled</span>
                  </small>
                </td>
                <td class="p-2" v-else>{{ edition.approved_at | date }}</td>
                <td class="p-2">
                  <a v-if="edition.url" :href="edition.url" target="_blank" class="text-grey-darkest hover:text-blue-dark">
                    <i class="fas fa-fw fa-eye"></i>
                  </a>
                </td>
                <td class="p-2">
                  <i class="fas fa-fw fa-pencil-alt hover:text-blue-dark cursor-pointer" @click="$emit('change-edition', edition.id)"></i>
                </td>
              </tr>
            </tbody>
          </table>

          <paginator :data="editions" @change="searchParams.page = $event"/>
        </div>
      </panel>
    </div>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapState } from 'vuex'

export default {
  created () {
    this.search()
  },
  data () {
    return {
      searchParams: {
        page: 1
      },
      editions: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  methods: {
    search () {
      v2Api.get('ezine-editions', {
        params: {
          ...this.searchParams,
          client_id: this.selectedOffice.client_id
        }
      }).then((response) => {
        this.editions = response.data
      })
    }
  },
  watch: {
    selectedOffice () {
      this.search()
    },
    'searchParams.page': function () {
      this.search()
    }
  }
}
</script>
